module.exports = __webpack_public_path__ + "static/media/Miknna-Electric.bb2d1f80.jpg";